export const Types = {
  GET_LIST_FERIADOS: "feriados/GET_LIST_FERIADOS",
  GET_LIST_FERIADOS_SUCCESS: "feriados/GET_LIST_FERIADOS_SUCCESS",
  GET_FERIADOS: "feriados/GET_FERIADOS",
  GET_FERIADOS_SUCCESS: "feriados/GET_FERIADOS_SUCCESS",
  EDIT_FERIADOS: "feriados/EDIT_FERIADOS",
  ADD_FERIADOS: "feriados/ADD_FERIADOS",
  DELETE_FERIADOS: "feriados/DELETE_FERIADOS",
  SEARCH_FERIADOS: "feriados/SEARCH_FERIADOS",
  CHANGE_PAGE_FERIADOS: "feriados/CHANGE_PAGE_FERIADOS",
  CHANGE_ROWS_PER_PAGE_FERIADOS: "feriados/CHANGE_ROWS_PER_PAGE_FERIADOS",
  GET_LIST_FERIADOS_SELECTS: "feriados/GET_LIST_FERIADOS_SELECTS",
  GET_LIST_FERIADOS_SUCCESS_SELECTS:
    "feriados/GET_LIST_FERIADOS_SUCCESS_SELECTS",
  DELETE_ALL_FERIADOS: "feriados/DELETE_ALL_FERIADOS"
};

const INITIAL_STATE = {
  data: [],
  dataList: [],
  loadingSelect: false,
  item: {},
  filter: {},
  page: 0,
  rowsPerPage: localStorage.getItem("@ecorban-app:rows")
    ? parseInt(localStorage.getItem("@ecorban-app:rows"), 10)
    : 10,
  total: 0
};

export default function feriados(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_LIST_FERIADOS:
      return { ...state };
    case Types.GET_LIST_FERIADOS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total: action.payload.total
      };
    case Types.GET_FERIADOS_SUCCESS:
      return {
        ...state,
        item: action.payload.data
      };
    case Types.ADD_FERIADOS:
      return { ...state };
    case Types.DELETE_FERIADOS:
      return { ...state };
    case Types.CHANGE_PAGE_FERIADOS:
      return { ...state, page: action.payload.page };
    case Types.SEARCH_FERIADOS:
      return { ...state, filter: action.payload.filter };
    case Types.CHANGE_ROWS_PER_PAGE_FERIADOS:
      return { ...state, rowsPerPage: action.payload.total };
    case Types.GET_LIST_FERIADOS_SELECTS:
      return { ...state, loadingSelect: true };
    case Types.GET_LIST_FERIADOS_SUCCESS_SELECTS:
      return {
        ...state,
        dataList: action.payload.feriados,
        loadingSelect: false
      };
    case Types.DELETE_ALL_FERIADOS:
      return { ...state };
    default:
      return state;
  }
}

export const Creators = {
  getListFeriados: () => ({
    type: Types.GET_LIST_FERIADOS
  }),
  getListFeriadosSuccess: (data, total) => ({
    type: Types.GET_LIST_FERIADOS_SUCCESS,
    payload: { data, total }
  }),
  getFeriados: id => ({
    type: Types.GET_FERIADOS,
    payload: { id }
  }),
  getFeriadosSuccess: data => ({
    type: Types.GET_FERIADOS_SUCCESS,
    payload: { data }
  }),
  editFeriados: data => ({
    type: Types.EDIT_FERIADOS,
    payload: data
  }),
  addFeriados: data => ({
    type: Types.ADD_FERIADOS,
    payload: data
  }),
  deleteFeriados: () => ({
    type: Types.DELETE_FERIADOS
  }),
  searchFeriados: filter => ({
    type: Types.SEARCH_FERIADOS,
    payload: { filter }
  }),
  changeFeriadosPage: page => ({
    type: Types.CHANGE_PAGE_FERIADOS,
    payload: { page }
  }),
  changeFeriadosRowsPerPage: total => ({
    type: Types.CHANGE_ROWS_PER_PAGE_FERIADOS,
    payload: { total }
  }),
  getListFeriadosSelects: () => ({
    type: Types.GET_LIST_FERIADOS_SELECTS
  }),
  getListFeriadosSuccessSelects: feriados => ({
    type: Types.GET_LIST_FERIADOS_SUCCESS_SELECTS,
    payload: { feriados }
  }),
  deleteAllFeriados: selected => ({
    type: Types.DELETE_ALL_FERIADOS,
    payload: { selected }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/feriados.js